import { DENOMINATOR, MARGIN_BOTTOM } from '../config';

const getYForTimelineComponent = (height, fraction) =>
  (height * (DENOMINATOR - fraction)) / DENOMINATOR - MARGIN_BOTTOM;

export { getYForTimelineComponent };
